import { Box } from "@mui/material";
import { useLayoutEffect, useRef } from "react";
import cn from "classnames";
import { observer } from "mobx-react";
import { useCallback, useEffect, useState } from "react";
import { Redirect, useRouteMatch } from "react-router-dom";

import useOrientation from "src/hooks/useOrientation";
import DesktopLayout from "../game-new2/layouts/layoutTypes/desktop/desktopLayout";
import NormalScreenSVG from "src/assets/icons/profileAndSettings/normalScreenSVG";
import useWindowSize from "src/hooks/useWindowSize";
import useStores from "src/hooks/useStores";
import { MAX_XL_TABLET } from "src/pages/game-new2/constants";
import GamePreview from "./components/GamePreview";

import LobbyTable from "./components/LobbyTable";
import { useStyles } from "./styles";
import { Friends } from "./components/Friends";
import { FriendsAndTopPlayersTab } from "./components/FriendsAndTopPlayersTab";
import TopPlayers from "./components/TopPlayers/TopPlayers";
import { ModalTypes, ModalProvider } from "../landing/utils/context";
import LoginForm from "../login";
import { PhoneAuth } from "src/dialogs/phone-auth";
import RegisterForm from "../register";

interface ILobby {
    tableIndex?: number | undefined;
}

const LobbyPage = ({ tableIndex }: ILobby) => {
    const styles = useStyles();
    const { width, height } = useWindowSize();
    const { generalStore, viewHistoryGameStore } = useStores();
    const orientation = useOrientation();
    const isMobileSize = width < MAX_XL_TABLET;
    const [isFriends, setIsFriends] = useState<boolean>(true);
    const [isOpenPreview, togglePreview] = useState<boolean | null>(null);
    const [modalState, setModalState] = useState({
        register: false,
        login: false,
        "phone-auth": false,
        businessMsg: false,
        notifications: false,
    });

    const openModal = (modal: ModalTypes) => {
        setModalState((prev) => ({ ...prev, [modal]: true }));
    };
    const closeModal = (modal: ModalTypes) => {
        setModalState((prev) => ({ ...prev, [modal]: false }));
    };

    useEffect(() => {
        if (localStorage.getItem("pieceSound") === null) {
            localStorage.setItem("pieceSound", "false");
        }
        if (localStorage.getItem("noteSound") === null) {
            localStorage.setItem("noteSound", "false");
        }
        if (localStorage.getItem("diceSound") === null) {
            localStorage.setItem("diceSound", "false");
        }
    }, [
        localStorage.getItem("pieceSound"),
        localStorage.getItem("noteSound"),
        localStorage.getItem("diceSound"),
    ]);

    useEffect(() => {
        let resetSet;
        if (isOpenPreview === false) {
            resetSet = setTimeout(() => {
                togglePreview(null);
            }, 300);
        }
        return () => clearTimeout(resetSet);
    }, [isOpenPreview]);

    const isPreviewGame = undefined;
    const showPreviewMemo = (status: boolean) => {};
    const showFriendsMemo = (status: boolean) => {};
    const gameContainerRef = useRef<any>(null);

    return (
        <>
            <ModalProvider.Provider value={{ openModal, closeModal }}>
                {modalState.register && <RegisterForm />}
                {modalState["phone-auth"] && <PhoneAuth />}
                {modalState.login && <LoginForm />}
                <div
                    className={cn(styles.container, {
                        isMobile: isMobileSize,
                    })}
                >
                    {/*<MainLobbyFilter />*/}
                    {/*<GameAndInviteFilter*/}
                    {/*    open={false}*/}
                    {/*    onClose={() => { }}*/}
                    {/*    filters={{*/}
                    {/*        status: {},     */}
                    {/*        type: {},       */}
                    {/*        showInvites: false,*/}
                    {/*        showGames: false,*/}
                    {/*    }}*/}
                    {/*    onApply={function (filters) {*/}
                    {/*        // логика применения фильтра*/}
                    {/*    }}*/}
                    {/*/>*/}

                    <LobbyTable />
                    {!isMobileSize && (
                        <>
                            <Box
                                className={cn(styles.rightBlockWrapper, {
                                    isView: viewHistoryGameStore.gameId,
                                })}
                            >
                                {viewHistoryGameStore.gameId ? (
                                    <>
                                        <GamePreview
                                            isPreviewGame={isPreviewGame}
                                            isFriends={
                                                isFriends &&
                                                generalStore.isDicechessMode
                                            }
                                            showPreview={showPreviewMemo}
                                            showFriends={showFriendsMemo}
                                            togglePreview={togglePreview}
                                            isFullScreen={null}
                                            isOpenPreview={isOpenPreview}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <FriendsAndTopPlayersTab
                                            value={
                                                isFriends
                                                    ? "frenemies"
                                                    : "topPlayers"
                                            }
                                            onChange={(newValue) => {
                                                setIsFriends(
                                                    newValue === "frenemies"
                                                );
                                            }}
                                        />
                                        {isFriends ? (
                                            <Friends />
                                        ) : (
                                            <TopPlayers />
                                        )}
                                    </>
                                )}
                            </Box>
                        </>
                    )}
                </div>
                <div
                    className={cn(styles.previewFullScreenBox, {
                        isOpen: isOpenPreview,
                        hidden: isOpenPreview === false,
                    })}
                >
                    <NormalScreenSVG
                        onClick={() => togglePreview(false)}
                        width={25}
                        height={25}
                        fillColor={"white"}
                    />
                    <GamePreview
                        isPreviewGame={isPreviewGame}
                        isFriends={isFriends && generalStore.isDicechessMode}
                        showPreview={showPreviewMemo}
                        showFriends={showFriendsMemo}
                        togglePreview={togglePreview}
                        isFullScreen={isOpenPreview}
                    />
                </div>
            </ModalProvider.Provider>
        </>
    );
};

export default observer(LobbyPage);
